import { useParams } from "react-router-dom";
import { PolicyViewer } from "~/components/policy-gql/policy-gql";
import { PolicyIdToMrn } from "~/lib/mrn";
import { useLoadPolicyQuery } from "~/operations";
import { Space } from "~/lib/types";
import { LoadingFailedPage, LoadingPage } from "~/components/loading";
import { SpaceOrWorkspaceScope } from "~/hooks/useScope";
import { setDocumentTitle } from "~/lib/commonUtils";

interface PolicyPageProps {
  space: Space;
  scope: SpaceOrWorkspaceScope;
  query: string;
}

export function PolicyPage({ space, scope }: PolicyPageProps) {
  const { policyId } = useParams();

  if (policyId == null) {
    throw new Error("missing ID for policy page");
  }

  const policymrn = PolicyIdToMrn(policyId);

  const { loading, data, error, refetch } = useLoadPolicyQuery({
    variables: { input: { spaceMrn: space.mrn, mrn: policymrn } },
  });

  if (loading) {
    return <LoadingPage what="policy" />;
  }

  const policy = data?.policy;

  if (error || !policy) {
    return <LoadingFailedPage what="policy" />;
  }

  setDocumentTitle([policy.name, "Security"]);

  return (
    <PolicyViewer
      policy={policy}
      space={space}
      scope={scope}
      onAssignChange={refetch}
    />
  );
}
